import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId, FullAuditableKeys, CurrencyNumber, Omit } from '../common';
import { PrintProviderSKUId } from './PrintProviderSKU';

export type PrintProviderSKUQuantityOptionId = Brand<number, 'PrintProviderSKUQuantityOptionId'>;
export const PrintProviderSKUQuantityOptionId = createBranded<PrintProviderSKUQuantityOptionId>();

export interface PrintProviderSKUQuantityOption extends HasId<PrintProviderSKUQuantityOptionId>, FullAuditable {
    printProviderSKUId: PrintProviderSKUId;
    quantity: number;
    priceAmountInCents: CurrencyNumber;
}

export interface QuantityOptionCrudDto {
    quantity: number;
    priceAmountInCents: CurrencyNumber;
}

export type PrintProviderSKUQuantityOptionDto = Omit<PrintProviderSKUQuantityOption, FullAuditableKeys | 'id'> & {
    label?: string;
};
